// DTM
import React from "react";
import styled from "styled-components";

import scale from "../helper/scaling";
import ArticleAbstract from "./ArticleAbstract";

const Wrapper = styled.div`
  width: 100%;
  float: left;
  height: 550px;
  position: relative;

  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 1100px) {
    height: ${scale(1100, 767, 550, 384, "vw")};
  }
  @media (max-width: 700px) {
    height: ${scale(700, 320, 700, 320, "vw")};
  }
`;
const Left = styled.div`
  width: 500px;
  height: 366px;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  position: absolute;
  left: calc(50% - 520px);
  top: 25px;

  @media (max-width: 1100px) {
    left: 25px;
    width: ${scale(1100, 767, 500, 343, "vw")};
    height: ${scale(1100, 767, 366, 251, "vw")};
  }
  @media (max-width: 700px) {
    background-position: left center;
    height: ${scale(700, 320, 315, 125, "vw")};
    width: 67%;
  }
`;
const Right = styled.div`
  width: 500px;
  height: 366px;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  position: absolute;
  right: calc(50% - 520px);
  bottom: 25px;

  @media (max-width: 1100px) {
    right: 25px;
    width: ${scale(1100, 767, 500, 343, "vw")};
    height: ${scale(1100, 767, 366, 251, "vw")};
  }
  @media (max-width: 700px) {
    background-position: right center;
    height: ${scale(700, 320, 315, 125, "vw")};
    width: 67%;
  }
`;
const GrayBox = styled.div`
  width: 745px;
  height: 392px;
  background-color: #f9f9f9;
  @media (max-width: 1100px) {
    width: ${scale(1100, 767, 745, 519, "vw")};
    height: ${scale(1100, 767, 392, 273, "vw")};
  }
  @media (max-width: 700px) {
    height: ${scale(700, 320, 580, 200, "vw")};
    width: ${scale(700, 320, 580, 200, "vw")};
  }
`;

class DecoratorImages extends ArticleAbstract {
  // image
  // title
  // body
  render() {
    return (
      <Wrapper>
        <GrayBox />
        <Left style={this.image()} />
        <Right style={this.image(true)} />
      </Wrapper>
    );
  }
}

export default DecoratorImages;



// WEBPACK FOOTER //
// ./src/components/DecoratorImages.js